const LoadingIcon = () => {
  //#region スタイル

  const containerStyle: React.CSSProperties = {
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  }

  const boxStyle: React.CSSProperties = {
    width: '130px',
    height: '130px',
    borderRadius: '100%',
    boxSizing: 'border-box',
    border: '10px dotted blue',
    animation: '3s linear infinite rotation',
    margin: 'auto auto 0 auto'
  }

  const labelStyle: React.CSSProperties = {
    fontSize: '20px',
    textAlign: 'center',
    margin: '0 auto auto auto'
  }

  //#endregion スタイル

  return (
    <>
      <style>
        {`@keyframes rotation{
            0%{ transform:rotate(0);}
            100%{ transform:rotate(360deg); }}
        `}
      </style>
      <div style={containerStyle}>
        <div style={boxStyle}></div>
        <div style={labelStyle}>Loading...</div>
      </div>
    </>
  )
}

export default LoadingIcon
